type Props = {
	label: string;
	icon?: React.ReactNode;
};

const HeaderContent = (props: Props) => {
	return (
		<div className="inline-flex align-items-center justify-content-center gap-4">
			{props.icon}
			<span className="tc-modal-header-title">{props.label}</span>
		</div>
	);
};

export default HeaderContent;
